import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../services/global';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject, of, throwError, from } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import * as moment from 'moment-timezone';

import { LazyLoadEvent } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import {MessageService} from 'primeng/api';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-portfolioanalysissuperv',
  templateUrl: './portfolioanalysissuperv.component.html',
  styleUrls: ['./portfolioanalysissuperv.component.css']
})
export class PortfolioanalysissupervComponent extends BaseCrudComponent {

  	translations:any;
	header:any;
	momentjs: any = moment;
    curr_date:any;
    today:any;
    dstart:any;
    dend:any;
    zones:any;
    totals:any;
    kpis:any;

	constructor(
	    srv: ApiService,
	    modalService: NgbModal,
	    storage: Storage,
  		router: Router,
  		private route: ActivatedRoute,
        public translate: TranslateService,
        private exportAsService: ExportAsService
	  ) {
	    super(srv, modalService, storage, router);
	    this.read_url = 'ReportPortfolioAnalysisSupervisor/Post';
        this.header = {};
        this.zones = [];
        this.rows = [];
        this.totals = [];
        this.kpis = {};
    }

    ngOnInit() {
        this.curr_date = this.momentjs().tz('America/Guayaquil').format('YYYY-MM');
        this.today = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.f_datefrom = this.curr_date;

    	this.translate.getTranslation(this.translate.currentLang)
        .subscribe((translations) => {
              this.translations = translations;
              super.ngOnInit();
              this.getList();
        });

        this.getZonesData().subscribe(x => {
            if(x != false){
                this.zones = x;
            }
        });
    }

    clearData(){
        this.header = {};
        this.rows = [];
        this.totals = [];
        this.kpis = {};
    }

    public getList(){
        var qst = this.read_url;
        var obj:any;
        //this.f_datefrom = '2020-10';
        this.clearData();

        obj = {
            Zone: null,
            Date: this.f_datefrom + '-01'
        }

        if( (this.f_custom1 != null) && (this.f_custom1 != 'null') ){
        	obj.Zone = this.f_custom1;
        }

        this.loadingList = true;
        //console.log(obj);

        this.srv.postCall(qst, obj).subscribe(x => {
        	this.loadingList = false;

            if(x.status){
                var rs = x.data;
                //console.log(rs);
                this.header = rs.header;
                this.totals = rs.detail.totals;
                this.rows = rs.detail.portfolioAnalysisSupervisor;
                this.kpis = rs.summary;

                this.rows.forEach(r => {
                	r.semaforo_collect = this.getColor(r.collectGoalPercent);
                });
            }
        });
    }

    getColor(par:any){
        var r:any;
        r = {};
        par = par.replace(' %', '');
        par = parseFloat(par.replace(/,/g, ''));

        if(par <= 80){
            //red
            r.color = '#ff0000';
            r.colorClass = 'orangered';
        }
        else if(par > 95){
            //green
            r.color = '#adff2f';
            r.colorClass = 'greenyellow';
        }
        else{
            //yellow
            r.color = '#ffff00';
            r.colorClass = 'yellow';
        }

        return r;
    }

    public getZonesData(){
        var par_url = 'ZoneBP/ListByUser';

        return this.srv.getCall(par_url).pipe(
                    mergeMap(data => {
                        let mydata:any = {status: false, data: [], message: ''};
                        mydata = data;
                        //console.log(data);
                        
                        if( mydata.status ){
                          return of(mydata.data);
                        }
                        else{
                          return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => {return of(false)})
                );
    }

    getPdfReportHeader(){
        var obj = [];

        obj.push([{content:'ANALISIS CARTERA (RESUMEN VENDEDORES)', colSpan:4, styles:{fontStyle:'bold', halign:'center'}}]);
        obj.push([
            {content:'Supervisor: ' + this.header['supervisor'], colSpan:2},
            {content:'Fecha: ' + this.today, colSpan:2}
        ]);
        obj.push([
            {content:'Jefe Ventas: ' + this.header['jefe'], colSpan:2},
            {content:'Mes: ' + this.curr_date, colSpan:2}
        ]);

        return obj;
    }

    exportReport(){
        var doc = new jsPDF('l','pt', 'a4');
        autoTable(doc, {body: this.getPdfReportHeader(), theme:'grid'});

        let header = [];
        let header_kpis = [['RESUMEN', 'TOTAL']];
        let footer = [];
        let x = [];

        //Section 2
        header = [];
        header.push(['ZONA', 'VENDEDOR', 'COBRO REAL', 'OBJ COBRO MES', '% CUMPL', ' ', 'CHEQUES POSFECHADOS MES', 'CARTERA VENCIDA', '1 A 30', '31 A 60', '61 A 90', '91+']);
        x = [];
        this.rows.forEach(i => {
            x.push([
            	i.zone,
            	i.seller,
                {content: '$'+i.collect, styles:{halign:'right'}},
                {content: '$'+i.collectGoal, styles:{halign:'right'}},
                i.collectGoalPercent,
                {content:'', styles:{fillColor:i.semaforo_collect.color, cellWidth:15}},
                {content: '$'+i.totalChequesPosfechadosMes, styles:{halign:'right'}},
                {content: '$'+i.pendingPortfolio, styles:{halign:'right'}},
                i.dias1a30,
                i.dias31a60,
                i.dias61a90,
                i.dias91enAdelante
            ]);
        });

        footer = [];
        footer.push([
        	{content:'', colSpan:2},
            {content: '$'+this.totals.collect, styles:{halign:'right'}},
            {content: '$'+this.totals.collectGoal, styles:{halign:'right'}},
            {content: this.totals.goalPercent, styles:{halign:'center'}},
            '',
            {content: '$'+this.totals.totalChequesPosfechadosMes, styles:{halign:'right'}},
            {content: '$'+this.totals.pendingPortfolio, styles:{halign:'right'}},
            {content: this.totals.dias1a30, styles:{halign:'center'}},
            {content: this.totals.dias31a60, styles:{halign:'center'}},
            {content: this.totals.dias61a90, styles:{halign:'center'}},
            {content: this.totals.dias91enAdelante, styles:{halign:'center'}}
        ]);

        autoTable(doc, {head:header, body: x, foot: footer, headStyles:{fontSize:7, halign:'center'}, bodyStyles:{fontSize:7, halign:'center'}, footStyles:{fontSize:7, fillColor:'#e9ecef', textColor:'#000', halign:'right'}});

        //KPIs
        // let boldstyle = {textColor:'#000',fontStyle:'bold', halign:'left'};
        // let totalstyle = {textColor:'#000',fontStyle:'bold', fillColor:'#e9ecef', halign:'left'};
        // let totalstyle2 = {textColor:'#000',fontStyle:'bold', fillColor:'#e9ecef'};

        // x = [];
        // x.push([{content:'Obj. Cobranza Mes', styles:boldstyle}, '$'+this.kpis.collectGoalMonth]);
        // x.push([{content:'Cobros Realizados', styles:boldstyle}, '$'+this.kpis.collect]);
        // x.push([{content:'% Cumpl Objetivo Cobro', styles:boldstyle}, this.kpis.collectGoalPercent]);


        // autoTable(doc, {head:header_kpis, body:x, bodyStyles:{halign:'right'}, headStyles:{fillColor:'#e9ecef', textColor:'#000', halign:'center'}, theme:'grid'});

        //Page Header and Footer
        doc = this.addPagesHeaderAndFooter(doc);
        doc.save('analisis_cartera_supervisor_' + this.curr_date);
    }

    addPagesHeaderAndFooter(doc:any) {
        var totalPages = doc.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.addImage(Global.logo_base64, 'PNG', 710, 10, 90, 20);

            // Footer
            var str = 'Página ' + i + ' de ' + totalPages;
            doc.setFontSize(10);

            // jsPDF 1.4+ uses getWidth, <1.4 uses .width
            var pageSize = doc.internal.pageSize;
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
            doc.text(str, 40, pageHeight - 10);
        }

        return doc;
    }

}
